import React from "react";

export const ChatProfileIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.0833 14H16.9167M14 11.0833V16.9167M14 24.5C16.0767 24.5 18.1068 23.8842 19.8335 22.7304C21.5602 21.5767 22.906 19.9368 23.7007 18.0182C24.4955 16.0996 24.7034 13.9884 24.2982 11.9516C23.8931 9.91476 22.8931 8.04383 21.4246 6.57538C19.9562 5.10693 18.0852 4.1069 16.0484 3.70176C14.0116 3.29661 11.9004 3.50455 9.98182 4.29927C8.0632 5.09399 6.42332 6.4398 5.26957 8.16652C4.11581 9.89323 3.5 11.9233 3.5 14C3.5 15.68 3.89433 17.2667 4.59667 18.6748C5.12517 19.7377 4.39017 21.1715 4.11017 22.218C4.04813 22.4495 4.04812 22.6932 4.11014 22.9246C4.17215 23.1561 4.294 23.3671 4.46343 23.5366C4.63287 23.706 4.84393 23.8279 5.07539 23.8899C5.30684 23.9519 5.55055 23.9519 5.782 23.8898C6.8285 23.6098 8.26233 22.8748 9.32517 23.4045C10.7779 24.1258 12.378 24.5008 14 24.5Z"
      />
    </svg>
  );
};
